module.exports = __webpack_public_path__ + "static/media/imag lateral.d8800f5b.svg";